module.exports = __webpack_public_path__ + "static/img/9.48178bb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/9.png
// module id = Jfcl
// module chunks = 0